import { IcomoonIcon } from '../../../atoms/IcomoonIcon'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'

type Props = {
  keywords: string
  setKeywords: React.Dispatch<React.SetStateAction<string>>
  className?: string
}

export const KeywordBox: React.FC<Props> = (props) => {
  const handleKeywordInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.setKeywords(e.target.value)
  }

  return (
    <div
      css={css`
        position: relative;
      `}
    >
      <IcomoonIcon
        name="search"
        css={css`
          position: absolute;
          font-size: 20px;
          top: 15px;
          left: 12px;
        `}
      />
      <input
        placeholder="スタートアップ、投資家、事業内容、タグを検索"
        type="text"
        value={props.keywords}
        onChange={handleKeywordInput}
        css={css`
          width: 100%;
          margin-bottom: 10px;
          background-color: ${colors.gray40};
          color: ${colors.text};
          font-size: 14px;
          height: 50px;
          border: 0;
          border-radius: 0;
          box-shadow: none;
          padding-left: 38px;
          &::placeholder {
            color: ${colors.textLight};
          }
          &:focus {
            box-shadow: none;
          }
        `}
        className={props.className}
      />
    </div>
  )
}
